import { Box, Grid, Divider, List } from "@mui/material";
import { H3, H4 } from "../components/Typography";
import CustomButton from "../components/CustomButton";
import { useNavigate } from "react-router-dom";
import { load } from "../constants/storage";
import { Player } from "@lottiefiles/react-lottie-player";
import Success from "../assets/Lottifies/sucessPayment.json";
import Failed from "../assets/Lottifies/failed.json";
import Pending from "../assets/Lottifies/pending.json";
import { DOWNLOAD_COIN_INVOICE, DOWNLOAD_INVOICE } from "../Api/EndPoints";
import { toast } from "react-hot-toast";
import { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
type GSTransactionDetailProps = {
  status: string;
  data: any;
  item: any;
  type: string;
  screenName?: any;
};

const GSTransactionDetail: React.FC<GSTransactionDetailProps> = (props) => {
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();

  const downloadInvoice = async (data: any) => {
    setLoading(true);
    let token = await load("token");
    const url: any =
      data?.txnType === "Buy Coin"
        ? DOWNLOAD_COIN_INVOICE + data.orderId
        : DOWNLOAD_INVOICE + data.orderId; // replace with your file name
    try {
      const response = await fetch(url, {
        headers: {
          Authorization: `${token}`,
        },
      });
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = data?.orderId + ".pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setLoading(false);
      toast.success("Invoice downloaded sucessfully.");
    } catch (error) {
      toast.error("Failed to download invoice.");
      setLoading(false);
    }
  };
  return (
    <>
      {loading ? (
        <Grid
          height="100vh"
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <Box
          sx={{
            background: "#F6F6F6",
            pl: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pr: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pb: 2,
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Player
            autoplay
            loop
            src={
              props?.item?.status === "TXN_SUCCESS"
                ? Success
                : props?.item?.status === "TXN_FAILURE"
                ? Failed
                : props?.item?.status === "INITIATED"
                ? Failed
                : props?.item?.status === "Executed" &&
                  props?.item?.txnType === "Redeemed"
                ? Success
                : props?.item?.status === "Executed" &&
                  props?.item?.txnType === "Sell"
                ? Success
                : Pending
            }
            style={{ height: "150px", width: "150px" }}
          />
          <H3
            color={
              props?.item?.status === "TXN_SUCCESS"
                ? "#22bb33"
                : props?.item?.status === "TXN_FAILURE"
                ? "#FF0000"
                : props?.item?.status === "INITIATED"
                ? "#FF0000"
                : props?.item?.status === "Executed" &&
                  props?.item?.txnType === "Redeemed"
                ? "#22bb33"
                : props?.item?.status === "Executed" &&
                  props?.item?.txnType === "Sell"
                ? "#22bb33"
                : "#FF9300"
            }
            sx={{
              fontFamily: "'Poppins', sans-serif",
              width: "40%",
              pt: 2,
              textAlign: "center",
            }}
          >
            {props?.item?.orderId?.includes("SELF") &&
            props?.item?.status === "TXN_SUCCESS"
              ? "Transaction Successful"
              : props?.item?.orderId?.includes("JOY") &&
                props?.item?.status === "TXN_SUCCESS"
              ? "Transaction Successful"
              : props?.item?.status === "TXN_SUCCESS"
              ? "Transaction Successful"
              : props?.item?.status === "TXN_FAILURE"
              ? "Transaction Failed"
              : props?.item?.status === "INITIATED"
              ? "Transaction Failed"
              : props?.item?.status === "Executed" &&
                props?.item?.txnType === "Redeemed"
              ? "Transaction Successful"
              : props?.item?.status === "Executed" &&
                props?.item?.txnType === "Sell"
              ? "Transaction Successful"
              : "Transaction Pending"}
          </H3>
          <Box
            sx={{
              border: "0.5px solid rgba(255, 239, 236, 0.5)",
            borderRadius: "12px",
            background: "#ffff",
            width: {
              md: "40%",
              xs: "90%",
            },
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            mt: 1.5,
            mb: 1,
            p: 2,
            }}
          >
            <Box
              component="img"
              src={
                props?.item?.productId === "gold"
                  ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/gold.svg"
                  :"https://acru-asset.s3.us-east-1.amazonaws.com/assets/silver.svg"
              }
              sx={sxStyleImage}
            />

            <H4
              fontSize={14}
              fontWeight={"700"}
              sx={{
                fontFamily: "'Poppins', sans-serif",
                pt: 2,
                pb: 0,
              }}
            >
              {props?.item?.productId === "gold" ? "Gold" : "Silver"}
            </H4>
            <List sx={{ width: "100%", bgcolor: "background.paper" }}>
              {props?.data?.map((item: any, key: any) => (
                <>
                  <Grid
                    justifyContent="space-between"
                    sx={{ display: "flex", p: 1 }}
                  >
                    <H4 sx={{ fontFamily: "'Poppins', sans-serif",}}>{item?.title}</H4>
                    <H4 sx={{ fontFamily: "'Poppins', sans-serif",}}>{item?.subTitle}</H4>
                  </Grid>
                  <Divider />
                </>
              ))}
            </List>
          </Box>
          {(props?.item?.txnType === "Buy" &&
            props?.item?.status === "TXN_SUCCESS") ||
          (props?.item?.txnType === "Buy Coin" &&
            props?.item?.status === "TXN_SUCCESS") ? (
            <Box
              sx={{
                borderRadius: "12px",
                width: {
                  md: "40%",
                  xs: "90%",
                },
                alignItems: "center",
                display: "flex",
                flexDirection:{
                  md:"row",
                  xs:'column'
                },

                mb: 1,
                justifyContent: "space-between",
              }}
            >
              <CustomButton
                title="Back to Home"
                onPress={() => navigate("/dashboard")}
                width={"45%"}
                sWidth={'100%'}
              />
              <CustomButton
                title="Download Invoice"
                onPress={() => downloadInvoice(props?.item)}
                width={"45%"}
                sWidth={'100%'}
              />
            </Box>
          ) : (
            <CustomButton
              title="Back to Home"
              onPress={() => navigate("/dashboard")}
              width={"40%"}
              sWidth={'90%'}
            />
          )}
        </Box>
      )}
    </>
  );
};

export default GSTransactionDetail;
const sxStyleImage = {
  height: 80,
  width: 80,
  mt: 2,
};
